import {
  useQuery,
} from 'react-query';

import { useMiddleman } from '@hubins/middleman';

export const useProfileHistory = (profileUuid, enabled = false) => useQuery(['profileHistory', profileUuid], () => {
  return middleman.promiseGet(`/ql/crm/profile/history/${profileUuid}`).then(res => res.data);
}, {
  refetchOnWindowFocus: false,
  refetchOnMount: false,
  refetchOnReconnect: false,
  enabled,
});